import type { IComponent } from "app/@types/ISwSettings";

export enum EAvailabilityMode {
    HOOK = "Hook",
    HIDDEN = "Hidden",
    OPEN = "Open",
}

function isNullOrUndefined<T>(value: T | null | undefined): value is null | undefined {
    return value === null || value === undefined;
}

export const isDeprecated = (component: IComponent): boolean => !!component.resources?.IsDeprecated;
export const isUnavailable = (component: IComponent): boolean => {
    return isNullOrUndefined(component?.resources?.AvaliabilityMode);
};

export const isLocked = (component: IComponent): boolean =>
    !isUnavailable(component) && component.resources.AvaliabilityMode === EAvailabilityMode.HOOK;
export const isHidden = (component: IComponent): boolean =>
    !isUnavailable(component) && component.resources.AvaliabilityMode === EAvailabilityMode.HIDDEN;
export const isOpen = (component: IComponent): boolean =>
    !isUnavailable(component) && component.resources.AvaliabilityMode === EAvailabilityMode.OPEN;

export const isAvailable = (component: IComponent): boolean => {
    return !isLocked(component) && !isHidden(component);
};
